import { useEffect, useState } from 'react'
import { Row, Col, Button, Modal, Pagination, Card, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'
import data from '../../../lib/backend/data'
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton'
import { confirmAlert } from 'react-confirm-alert'
import Select from 'react-select';
import BuscadorUsuarios from '../../usuarios/buscador';
import { fechaATexto } from '../../../lib/helpers/helpers';
import { useDispatch } from 'react-redux';
import { cerrarSesion } from '../../../redux/actions/session';
import LoadingIntegrations from '../../general/loadingAnimations/loadingIntegrations';

const ApiKeysListado = (props) => {
    const [ usuarios, setUsuarios ] = useState([{ value:'all_access', label:'Todos los permisos'}])
    const [ conductores, setConductores ] = useState([])
    const [ loadingConductores, setLoadingConductores ] = useState(true)
    const [ creando, setCreando ] = useState(false)
    const [ loadingUsuarios, setLoadingUsuarios ] = useState(true)
    const [ nuevaKey, setNuevaKey ] = useState({})
    const [ openModal, setOpenModal ] = useState(false)
    const [ idActualizando, setIdActualizando ] = useState(false)
    const [ openModalKC, setOpenModalKC ] = useState(false)
    const [ keyCreada, setKeyCreada ] = useState(false)
    const [ total, setTotal ] = useState(0)
    const [ pagina, setPagina ] = useState(1)
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(props.condicion_default ? props.condicion_default : {})
    const token = props.token ? props.token : false
    const trash = props.trash ? props.trash : false
    const dispatch = useDispatch()

    const crearNuevaKey = async () => {
        const requeridos = [
            { value:"titulo", label: "Título" },
            { value:"id_user", label: "Permisos" }
        ]
        let faltantes = []
        requeridos.map(campo => {
            if(!nuevaKey[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        setCreando(true)
        return fetch(`${data.urlapi}/integraciones/apikeys`,{
            method:'POST',
            body: JSON.stringify(nuevaKey),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            setCreando(false)
            if(!res){
                toast.error('Sin datos')
                return setLoadingConductores(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingConductores(false)
            } else if(res._id){
                setKeyCreada(res)
                conductores.unshift(res)
                setOpenModal(false)
                setOpenModalKC(true)
                setConductores(prev => [...[], ...conductores])
            }
            return setLoadingConductores(false)
        })
        .catch(error => {
            setCreando(false)
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoadingConductores(false)
        })

    }

    const obtenerUsuarios = async () => {
        return fetch(`${data.urlapi}/usuarios/list-full`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return setLoadingUsuarios(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingUsuarios(false)
            } else if(Array.isArray(res) !== false){
                const opciones = res.map(u => ({ value: u._id, label: `${u.email} · ${u.nombres}` }))
                setUsuarios(prev => [...prev, ...opciones])
            }
            return setLoadingUsuarios(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoadingUsuarios(false)
        })
    }

    const obtenerConductores = async (page, query)=>{
        setLoadingConductores(true)
        if(query) if(trash === true) query.status = 'trash'
        const condicion = query ? query : condicion_busqueda
        return fetch(`${data.urlapi}/integraciones/apikeys/list`,{
            method:'POST',
            body: JSON.stringify({
                condicion,
                pagina: page
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(!res){
                toast.error('Sin datos')
                return setLoadingConductores(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingConductores(false)
            }
            if(Array.isArray(res.datos) !== false){
                setConductores(res.datos)
                setTotal(res.total)
            }
            return setLoadingConductores(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoadingConductores(false)
        })
    }

    const paginar = (page,ignorar) => {
        if(ignorar) return false
        setPagina(page)
        obtenerConductores(page)
    }

    const handleClose = () => {
        setOpenModal(false)
        setOpenModalKC(false)
    }

    const handleChangeNuevaKey = (e) => {
        const { name, value } = e.target
        nuevaKey[name] = value
        return setNuevaKey(nuevaKey)
    }

    const onChangeUsuario = (e) => {
        if(!e.value) return
        nuevaKey.id_user = e.value
        return setNuevaKey(nuevaKey)
    }

    const modalFiltro = () => {
        
        return <Modal show={openModal} size="lg" onHide={()=>handleClose()}
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title>Filtrar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col xs={6} className="mb-2">
                    <label className='d-block form-control-label'>Título</label>
                    <input className='form-control' name="titulo" onChange={handleChangeNuevaKey} />
                </Col>
                <Col xs={6} className="mb-2">
                    <BuscadorUsuarios token={token} onChange={(e) => onChangeUsuario(e)} label="Heredar permisos de usuario" />
                </Col>
                <Col md={12}>
                    { creando === true ? <Spinner animation='border' /> : <Button size="sm" variant="success" onClick={() => crearNuevaKey()}>CREAR</Button> }
                </Col>
            </Row>
        </Modal.Body>
        
      </Modal>
    }

    const copiarTexto = (id) => {
        toast.info("Copiado")
        return navigator.clipboard.writeText(id)
    }
    
    const modalKC = () => {
        
        return <Modal show={openModalKC} size="lg" onHide={()=>handleClose()}
        centered
        >
        <Modal.Body>
            <h2 className='mb-0'>¡Generada exitosamente!</h2>
            <p>Esta es tu llave de API, solo podrás ver este valor una única vez por seguridad, asegúrate de guardarla en un lugar seguro.</p>
            <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>Has click para copiar</Tooltip>
          }
        >
            <h3 className='hover' style={{ padding: 10, fontWeight:'lighter', backgroundColor: '#e9e9e9', borderRadius: 7 }} onClick={() => copiarTexto(keyCreada._id)} >{keyCreada._id} <i className="far fa-copy"></i></h3>
            </OverlayTrigger>
        </Modal.Body>
        
      </Modal>
    }

    const paginacion = (ciclo, total) => {
        const cantidad = Math.ceil(total / ciclo)
        return <div>
            <Pagination size='sm'>
                {
                    Array.from(Array(cantidad).keys()).map(number => {
                        const active = pagina === (number+1) ? true : false
                        return <Pagination.Item key={number+1} active={active} onClick={()=>paginar(number+1,active)} >{number+1}</Pagination.Item>
                    })
                }
            </Pagination>
        </div>
    }

    useEffect(() => {
        obtenerConductores(1, false)
        obtenerUsuarios()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const cargandoScreen = () => {
        return <LoadingIntegrations />
    }

    const confirmarEliminado = async (id) => {
        setLoadingConductores(true)
        return fetch(`${data.urlapi}/integraciones/apikeys?id=${id}`,{
            method:'DELETE',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return setLoadingConductores(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingConductores(false)
            } else if(res._id){
                toast.success('Eliminada exitosamente')
                return setTimeout(() => {
                    window.location = '/configuracion'
                }, 1000);
            }
            return setLoadingConductores(false)
        })
        .catch(error => {
            toast.error(`Error al consultar la información: ${error.message}`)
            return setLoadingConductores(false)
        })
    }

    const solicitarEliminarKey = (id) => {
            return confirmAlert({
                title: `¿Estás seguro?`,
                message: `Estás a punto de eliminar este registro, esta acción no se puede deshacer`,
                buttons: [
                  {
                    label: 'CONFIRMAR',
                    onClick: () => confirmarEliminado(id)
                  },
                  {
                    label: 'CANCELAR',
                    onClick: () => false
                  }
                ]
              })
    }

    const actualizarApiKey = async (objeto) => {
        return fetch(`${data.urlapi}/integraciones/apikeys`,{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
                return setIdActualizando(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setIdActualizando(false)
            } else if(res._id){
                toast.success("Actualizado exitosamente")
            }
            return setIdActualizando(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setIdActualizando(false)
        })
    }

    const handleChangeSelect = (e,_id) => {
        setIdActualizando(_id)
        return actualizarApiKey({
            _id,
            id_user: e.value
        })
    }

    const cambiarStatus = ( _id, active ) => {
        setIdActualizando(_id)
        const i = conductores.findIndex(u => u._id === _id)
        conductores[i].active = active
        setConductores(prev => [...[], ...conductores])
        return actualizarApiKey({
            _id,
            active
        })
    }

    const tabla_registros = (registros) => {
        if(loadingConductores===true) return cargandoScreen()
        if(registros.length < 1) return  <div>
            <h5>Nada por aquí</h5>
            <p>No hay registros en esta sección</p>
        </div>
        return <div>
            <h5>{(registros.length * pagina) - registros.length + 1} - {registros.length * pagina} <b style={{ fontWeight:'lighter' }}>de {total}</b></h5>
            {paginacion(data.pagina, total)}
            {
                        registros.map(usuario => {

                            let item_default = false
                            const i_default = usuarios.findIndex(u => u.value === usuario.id_user)
                            if(i_default > -1 ){
                                item_default = { value: usuarios[i_default].value, label: usuarios[i_default].label }
                            }

                            return <Card key={`user-${usuario._id}`} className="p-3 mb-3">
                                <Row>
                                    <Col md={4}>
                                        <span style={{ fontSize: 12 }}>Creada: { fechaATexto(usuario.createdAt) }</span>
                                        <h4>{usuario.titulo}</h4>
                                        <h4 style={{ padding:10, fontSize:15, textAlign:'center', fontWeight:'lighter', backgroundColor: '#e9e9e9', borderRadius: 7 }}>
                                            ...{usuario._id.substr(-8)}
                                            { idActualizando === usuario._id ? <Spinner animation="border" /> : false }
                                        </h4>
                                    </Col>
                                    <Col md={4}>
                                    <label className="form-control-label">Heredar permisos de usuario</label>
                                    <Select 
                                                    style={{ marginBottom: 10 }}
                                                    onChange={(e)=>handleChangeSelect(e,usuario._id)}
                                                    options={usuarios}
                                                    defaultValue={item_default}
                                                    isLoading={loadingUsuarios}
                                                    noOptionsMessage={()=>'Sin opciones'}
                                                    placeholder="Selecciona un usuario..."
                                                />

                                    <h6 className='hover' style={{ marginTop: 14 }} onClick={() => cambiarStatus(usuario._id, usuario.active === true ? false : true )}>{ usuario.active === true ? 
                                    <i className="fas text-success fa-check-square"></i> :
                                    <i className="far fa-square"></i> } Activo</h6>
                                    
                                    </Col>
                                    <Col md={4} className="text-right">
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Eliminar</Tooltip>
                                            }
                                            >
                                        <Button variant="danger" onClick={() => solicitarEliminarKey(usuario._id)} ><i className="far fa-trash-alt"></i></Button>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Card>
                        })
            }
        </div>
    }

    return <div>
        {modalFiltro()}
        <Row>
            <Col md={12}>
            {modalKC()}
            <h4>Llaves de API <i className="fa-solid fa-circle-plus text-primary hover" onClick={() => setOpenModal(true)}></i></h4>
            {tabla_registros(conductores)}
            </Col>
        </Row>
    </div>

}

export default ApiKeysListado